define('evicommon/spf/model/paginate',['require','exports','module','backbone'],function(require, exports, module){
  var Backbone = require('backbone');

  var Paginate = Backbone.Model.extend({

    defaults: {
      size: 25,
      number: 1
    },

    page: function() {
      if (arguments.length > 0) {
        this.set(Paginate.PAGE, arguments[0]);
        return this;
      }
      return this.get(Paginate.PAGE);
    },

    size: function() {
      if (arguments.length > 0) {
        this.set(Paginate.SIZE, arguments[0]);
        return this;
      }
      return this.get(Paginate.SIZE);
    },

    totalPages: function() {
      return this.get(Paginate.TOTAL_PAGES);
    },

    totalItems: function() {
      return this.get(Paginate.TOTAL_ITEMS);
    },

    toJSON: function() {
      var data = {};
      if (this.has(Paginate.SIZE)) {
        data.size = this.get(Paginate.SIZE);
      }
      if (this.has(Paginate.PAGE)) {
        data.number = this.get(Paginate.PAGE);
      }
      return data;
    }

  },
  {
    PAGE: 'number',
    SIZE: 'size',
    TOTAL_PAGES: 'totalPages',
    TOTAL_ITEMS: 'totalElements',
    QUERY_PAGE: 'page',
    QUERY_SIZE: 'size'
  });

  module.exports = Paginate;
});

